import { Component, ViewEncapsulation } from '@angular/core';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent {
  
  //-- CONSTRUCTOR -----------------------------------------------------|
  imageBaseUrl: string = ""
  constructor(private appService: AppService) {
    this.imageBaseUrl = this.appService.ENV.IMAGE_BASE_URL;
  }

  //--------------------------------------------------------------------|
}
